/**
 * CPF utilities — máscara + validação de dígitos verificadores brasileiros.
 *
 * Usar tanto no AuthModal quanto no wizard /cadastrar para garantir que o mesmo
 * CPF validado no frontend é o que vai para o backend. O backend também
 * revalida (defense-in-depth) — ver `core/cpf_validation.py`.
 */

/** Aplica máscara 000.000.000-00 enquanto o usuário digita. */
export const formatCpf = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 11);
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/** Retorna apenas dígitos (para enviar ao backend). */
export const stripCpf = (value) => String(value || '').replace(/\D/g, '');

/**
 * Valida CPF brasileiro:
 *  • 11 dígitos
 *  • não pode ser sequência (000... 111...)
 *  • 2 dígitos verificadores corretos (algoritmo da Receita Federal)
 */
export const validateCpf = (cpf) => {
  const digits = stripCpf(cpf);
  if (digits.length !== 11) return false;
  if (/^(\d)\1+$/.test(digits)) return false;

  // Primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(digits[i], 10) * (10 - i);
  let rem = (sum * 10) % 11;
  if (rem === 10 || rem === 11) rem = 0;
  if (rem !== parseInt(digits[9], 10)) return false;

  // Segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(digits[i], 10) * (11 - i);
  rem = (sum * 10) % 11;
  if (rem === 10 || rem === 11) rem = 0;
  if (rem !== parseInt(digits[10], 10)) return false;

  return true;
};
